import React, { useState } from 'react';
import AuthorLoginPage from '../../pages/auth/AuthorLoginPage';
import logo from '../../../assets/images/brandlogo.png';
import { Divider, Dropdown } from 'rsuite';
import { IoMenu, IoSearch } from "react-icons/io5";
import { FiMenu } from "react-icons/fi";
import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import './MainHeader.css';
import axios from "axios";
import { IoMdMenu } from 'react-icons/io';
require('typeface-poppins')

export default function MainHeader({ onSearch }) {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [query1, setQuery] = useState('');
  const navigation = useNavigate()
  const location = useLocation()

  const handleInputChange1 = (e) => {
    setQuery(e.target.value);
  };

  // const handleSearch1 = async () => {
  //   if (!query1) return;

  //   try {
  //     await onSearch(query1); 
  //   } catch (err) {
  //     console.error(err);
  //   }   
  // };

  const navigate = useNavigate();

  const handleclickCreateaccount = () => {
    navigate('/');
  };

  const handleSearch1 = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/filterdata.php`, {
        genres: JSON.stringify(selectedGenres),
        categories: JSON.stringify(selectedCategories),
        regions: JSON.stringify(selectedRegions),
        query: query1 // This is the input from the text box
      });

      if (response.data.success) {
        setFilteredUsers(response.data.users);
        navigate('/ResultSearchingPage', {
          state: { users: response.data.users }
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const handleclickAuthormeet = () => {
    navigate('/WelcomeAuthormeetPage');
  };

  // User Login Conditions for Dropdowns
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const SizeDropdown = props => (
    <Dropdown appearance="default" {...props}>
      {/*
      <Dropdown.Item>
        <button onClick={handleclickCreateaccount} className='mainheadercreateButton btn btn-warning w-100'>Create an Account</button>  
      </Dropdown.Item> 
      */}
      {/* <Dropdown.Item>
        <button onClick={handleclickAuthormeet} className='mainheaderloginButton btn btn-warning w-100'>Login to AuthorMeet</button>
      </Dropdown.Item> */}
      <button onClick={handleclickAuthormeet} className='mainheaderloginButton btn btn-warning w-100'>Login to AuthorMeet</button>
    </Dropdown>
  );

  const SizeDropdownOne = props => (
    <div>
      {/* <Dropdown appearance="default" {...props}>    
      <Dropdown.Item>
        <button onClick={handleclickAuthormeet} className='mainheaderloginButton btn btn-warning w-100'>Login to AuthorMeet</button>  
      </Dropdown.Item>
    </Dropdown> */}
      <button onClick={handleclickAuthormeet} className='mainheaderbeforeLogin'><IoMenu className='menuIcon' /></button>
    </div>

  );

  return (
    <>
      {isMobile ? (
        <header className='mobilmainHeader'>
          <div className='mobilmainheaderContent'>
            <div className='container'>
              <nav className='mobilmainheaderNav mobilmainheadernavExpand flex-wrap'>
                <a href="/" className='mobilmainheaderLeft me-auto'>
                  <div className='mobilmainheaderBrand d-flex align-items-start'>
                    <img src={logo} className='mobilmainheaderBrandimage img-fluid' />
                    <div className='mobilmainheaderbrandTitles'>
                      <h6> AuthorMeet </h6>
                      <p> Powered by: Bookworm Central </p>
                    </div>
                  </div>
                </a>
                <div>
                  <SizeDropdown className='mobilmainheadertopDropdown' placement="bottomEnd" icon={<FiMenu />} noCaret />
                </div>
              </nav>
              <div className='mobilmainheadersearchWrapper'>
                <input type="text" className='mobilmainheadersearchInput' value={query1} onChange={handleInputChange1} placeholder="Author Name/Keyword" />
                <button className='mobilmainheadersearchButton' onClick={handleSearch1}>
                  <IoSearch className='mobilmainheadersearchIcon' />
                </button>
              </div>
            </div>
          </div>
        </header>
      ) : (
        <header className='mainHeader'>
          <div className='mainheaderContent'>
            <div className='container'>
              <nav className='mainheaderNav mainheadernavExpand flex-wrap'>
                <a href="/" className='mainheaderLeft me-auto'>
                  <a href="https://www.authormeet.net/" >
                    <div className='mainheaderBrand d-flex align-items-start'>
                      <img src={logo} className='mainheaderBrandimage img-fluid' />
                      <div className='mainheaderbrandTitles'>
                        <h6> AuthorMeet </h6>
                        <p> Powered by: Bookworm Central </p>
                      </div>
                    </div>
                  </a>
                </a>
                <div className='mainheadersearchWrapper'>
                  <input type="text" className='mainheadersearchInput' value={query1} onChange={handleInputChange1} placeholder="Author Name/Keyword" />
                  <button className='mainheadersearchButton' onClick={handleSearch1}>
                    <IoSearch className='mainheadersearchIcon' />
                  </button>
                </div>

                {
                  location.pathname == "/" ? <p className='findYourOrg' onClick={() => navigation('/find-your-school')}>Find Your Event</p> : null
                }


                {isLoggedIn ? (
                  <SizeDropdown className="mainheadertopDropdown" placement="bottomEnd" icon={<FiMenu />} noCaret />
                ) : (
                  <SizeDropdownOne className="mainheaderbeforeLogin" placement="bottomEnd" icon={<FiMenu />} noCaret />
                )}

              </nav>
            </div>
          </div>
        </header>
      )}
    </>
  )
}
